import React from "react";

import { GridColumn } from "@progress/kendo-react-grid";
import { checkBoxCell, customCell, GridPanel, IRoutedTabProps } from "@selas/ui-components";
import { useTranslation } from "react-i18next";

import Endpoint from "../../../services/api/endpoint";
import { hasPermission } from "../../../services/authentication";
import { Permission } from "../../../utils/enums";
import ProjectGroupEditor from "../../editors/masterdata/projectGroup";

const ProjectGroups: React.FC<IRoutedTabProps> = () => {
	const { t } = useTranslation();

	return (
		<GridPanel
			listEndpoint={Endpoint.ProjectGroupsList}
			endpoint={Endpoint.ProjectGroups}
			addScreen={{ screen: ProjectGroupEditor, isAllowed: hasPermission(Permission.ProjectGroupsAdd) }}
			editScreen={{ screen: ProjectGroupEditor, isAllowed: hasPermission(Permission.ProjectGroupsUpdate) }}
			delete={{ isAllowed: hasPermission(Permission.ProjectGroupsDelete) }}
			filter={{
				logic: "and",
				filters: [
					{
						field: "active",
						operator: "eq",
						value: true
					}
				]
			}}
		>
			<GridColumn field="name" title={t("name")} />
			<GridColumn field="active" title={t("active")} filter="boolean" width="160px" cell={customCell(checkBoxCell())} />
		</GridPanel>
	);
};

export default ProjectGroups;
